import React from 'react';
import Icon from '../../../components/AppIcon';

const TierBenefits = ({ user, tierInfo }) => {
  const { currentTier, nextTier, progress, benefits, exclusiveContent } = tierInfo;

  const tierColors = {
    'Intro': 'bg-secondary/10 border-secondary/20 text-secondary-foreground',
    'All Access': 'bg-primary/10 border-primary/20 text-primary-foreground',
    'Flex': 'bg-accent/10 border-accent/20 text-accent-foreground',
    'Premium': 'bg-success/10 border-success/20 text-success-foreground'
  };

  const tierIcons = {
    'Intro': 'User',
    'All Access': 'Users',
    'Flex': 'Zap',
    'Premium': 'Crown'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-wellness">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-heading font-semibold text-foreground">Membership Benefits</h2>
        <button 
          onClick={() => window.location.href = '/member-profile'}
          className="text-primary hover:text-primary/80 transition-wellness text-sm font-medium"
        >
          Upgrade
        </button>
      </div>
      {/* Current Tier Status */}
      <div className={`rounded-lg p-4 border mb-6 ${tierColors?.[currentTier] || tierColors?.['Intro']}`}>
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
            <Icon name={tierIcons?.[currentTier] || 'User'} size={24} color="white" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold">{currentTier} Member</h3>
            <p className="text-sm opacity-80">Active since {user?.memberSince}</p>
          </div>
        </div>

        {/* Progress to Next Tier */}
        {nextTier && (
          <div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium">Progress to {nextTier}</span>
              <span className="text-sm">{progress?.current}/{progress?.required} points</span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-2">
              <div 
                className="bg-white h-2 rounded-full transition-all duration-500 ease-out"
                style={{ width: `${(progress?.current / progress?.required) * 100}%` }}
              ></div>
            </div>
          </div>
        )}
      </div>
      {/* Current Benefits */}
      <div className="mb-6">
        <h3 className="text-lg font-heading font-medium text-foreground mb-3">Your Benefits</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 rounded-lg bg-muted/30 border border-border">
              <div className="w-8 h-8 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Check" size={16} color="white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{benefit?.name}</p>
                <p className="text-xs text-muted-foreground">{benefit?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Exclusive Content */}
      <div>
        <h3 className="text-lg font-heading font-medium text-foreground mb-3">Exclusive Content</h3>
        <div className="space-y-3">
          {exclusiveContent?.map((content, index) => (
            <div 
              key={index}
              onClick={() => window.location.href = content?.link}
              className="flex items-center space-x-3 p-3 rounded-lg border border-border hover:border-primary/20 hover:bg-primary/5 transition-wellness cursor-pointer"
            >
              <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={content?.icon} size={18} color="white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{content?.title}</p>
                <p className="text-xs text-muted-foreground">{content?.description}</p>
              </div>
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-accent rounded-full animate-breathing"></div>
                <span className="text-xs font-caption text-accent-foreground">New</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TierBenefits;